/** Výchozí počet řádků na stránku — combobox i pick modal. */
export const DEFAULT_SELECTOR_PAGE_SIZE = 10;

/** Volby v přepínači velikosti stránky (pick modal). */
export const DEFAULT_SELECTOR_PAGE_SIZE_OPTIONS = [10, 20, 30, 50] as const;

/** Prodleva před API dotazem po změně query inputu (ms). */
export const DEFAULT_SEARCH_DEBOUNCE_MS = 300;

export const DEFAULT_LIST_PICKER_MODE = 'react' as const;
export const DEFAULT_PICK_MODAL_WIDTH = 'xl' as const;
